export default __webpack_public_path__ + "static/media/09-TechPeople-iStock-517015280-cropped.e0639387.jpg";